import { theme } from '@notino/react-styleguide';

import { styled } from '@linaria/react';

export const LoyaltyProgramBannerWrapper = styled.div`
  margin-bottom: 1.5rem;
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 0.5rem;
  border-radius: 0.25rem;
  padding: 0.5rem 0.75rem;
  background: linear-gradient(90deg, #f8edf4 0%, #fef9f7 100%);
`;

export const CtaLink = styled.a`
  display: inline-block;
  ${theme.typography.labelSmall}
  text-decoration: underline;
  &:hover {
    text-decoration: none;
  }
`;
